import {
  ApplicationConfig,
  APP_INITIALIZER,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {provideHttpClient} from "@angular/common/http";
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withRouterConfig({onSameUrlNavigation: 'reload'})),
    provideAnimationsAsync(),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [MatIconRegistry, DomSanitizer],
      useFactory: (iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) => () => {
        // Register custom SVG icons here
        iconRegistry.addSvgIcon(
          'guitar',
          sanitizer.bypassSecurityTrustResourceUrl('assets/icons/guitar.svg')
        );
        iconRegistry.addSvgIcon(
          'sharp',
          sanitizer.bypassSecurityTrustResourceUrl('assets/icons/sharp.svg')
        );
        iconRegistry.addSvgIcon(
          'bass-clef',
          sanitizer.bypassSecurityTrustResourceUrl('assets/icons/bass-clef.svg')
        );
      }
    }
  ]
};
